import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ArrowUpRight } from 'lucide-react';
export function AgencyPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenDismissed, setHasBeenDismissed] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (hasBeenDismissed) return;
      const scrollPosition = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollPercentage = scrollPosition / (documentHeight - windowHeight);
      if (scrollPercentage > 0.5 && !isVisible) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasBeenDismissed, isVisible]);
  const handleClose = () => {
    setIsVisible(false);
    setHasBeenDismissed(true);
  };
  return <AnimatePresence data-id="element-9">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 20
    }} className="fixed bottom-6 right-6 z-50 max-w-sm w-[calc(100%-3rem)] bg-white border-4 border-black shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]" data-id="element-10">
          <div className="bg-black p-4 flex justify-between items-center text-white" data-id="element-11">
            <span className="font-oswald font-bold text-lg tracking-widest uppercase" data-id="element-12">
              Розробка сайтів
            </span>
            <button onClick={handleClose} className="hover:rotate-90 transition-transform" data-id="element-13">
              <X className="w-6 h-6" data-id="element-14" />
            </button>
          </div>

          <div className="p-6" data-id="element-15">
            <p className="text-base font-medium mb-6" data-id="element-16">
              Цей сайт ми можемо зробити для вас повністю під ключ, адаптувати
              під всі ваші потреби.
            </p>

            <div className="border-2 border-black p-3 mb-6 text-center bg-[#F4F4F5]" data-id="element-17">
              <span className="font-bold text-black text-sm uppercase tracking-widest" data-id="element-18">
                Вартість під ключ — 8 000 грн.
              </span>
            </div>

            <div className="flex flex-col gap-3" data-id="element-19">
              <a href="tel:+380508399309" className="flex items-center justify-between w-full px-4 py-3 bg-black hover:bg-white hover:text-black text-white border-2 border-black transition-colors text-sm font-bold uppercase tracking-widest" data-id="element-20">
                +380 50 839 9309
                <ArrowUpRight className="w-5 h-5" data-id="element-21" />
              </a>
              <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-between w-full px-4 py-3 bg-white hover:bg-black hover:text-white text-black border-2 border-black transition-colors text-sm font-bold uppercase tracking-widest" data-id="element-22">
                jetly.agency/ua
                <ArrowUpRight className="w-5 h-5" data-id="element-23" />
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}